import React from 'react';
import { Capacitor } from '@capacitor/core';
import { Smartphone } from 'lucide-react';

interface PlatformGuardProps {
  children: React.ReactNode;
}

// iOS-only guard: blocks non-iOS ONLY when running as a native app via Capacitor
// Web preview remains available for development.
export const PlatformGuard: React.FC<PlatformGuardProps> = ({ children }) => {
  const platform = Capacitor.getPlatform();
  const isNative = Capacitor.isNativePlatform();
  const isAllowed = !isNative || platform === 'ios';

  if (isAllowed) return <>{children}</>;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <article className="max-w-md w-full border rounded-xl p-6 bg-card text-card-foreground shadow">
        <header className="flex items-center gap-3 mb-2">
          <Smartphone className="h-5 w-5 text-muted-foreground" />
          <h1 className="text-lg font-semibold">Unsupported Platform</h1>
        </header>
        <p className="text-sm text-muted-foreground">
          This app currently runs only on iOS (iPhone and iPad). Please open the app on an iOS device.
        </p>
      </article>
    </div>
  );
};
